export type BusinessNotificationPriority = 'normal' | 'high';

export interface BusinessNotificationRemotePushParams {
  targetUserId: string;
  title: string;
  body: string;
  data?: Record<string, any>;
  priority?: BusinessNotificationPriority;
}

export type BusinessNotificationRemotePush = (
  params: BusinessNotificationRemotePushParams,
) => Promise<void>;

let remotePushAdapter: BusinessNotificationRemotePush = async (params) => {
  console.log('[BusinessNotificationHelper] Remote push adapter not registered. Payload ignored:', params);
};

export interface BusinessNotificationAdapterOptions {
  remotePush?: BusinessNotificationRemotePush;
}

export const registerBusinessNotificationAdapters = (
  options: BusinessNotificationAdapterOptions,
): void => {
  if (options.remotePush) {
    remotePushAdapter = options.remotePush;
  }
};

export const sendBusinessNotificationRemotePush = (
  params: BusinessNotificationRemotePushParams,
): Promise<void> => remotePushAdapter(params);
